import React, { useEffect, useState } from "react";
import TripDetailsGalleryAPI from "../api/TripDetailsGalleryAPI";
// import LazyLoad from "react-lazyload";
import NotFound from "../assets/media/page_not-found.jpg";

const Gallery = () => {
  const [galleryImages, setGalleryImages] = useState([]);
  const [columnCount, setColumnCount] = useState(4);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch data
  useEffect(() => {
    const fetchAllTrips = async () => {
      try {
        setIsLoading(true);
        const res = await TripDetailsGalleryAPI.getTripDetailsGallery();

        if (!res?.data || res.data.length === 0) {
          setGalleryImages([]);
          return;
        }

        // Flatten images safely
        const images = res.data.flatMap((item) =>
          (item?.gallery || []).map((imagePath) => ({
            src: `https://sortedtrips.in/admin/${imagePath}`,
            alt: "Trip Image",
          }))
        );

        setGalleryImages(images);
      } catch (err) {
        console.error("Error fetching trip gallery:", err);
        setError("Unable to load gallery images.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchAllTrips();
  }, []);

  // Distribute images into columns
  const distributeImagesIntoColumns = () => {
    const columns = Array.from({ length: columnCount }, () => []);
    galleryImages.forEach((image, index) => {
      columns[index % columnCount].push(image);
    });
    return columns;
  };

  const columns = distributeImagesIntoColumns();

  const styles = {
    galleryRow: {
      display: "flex",
      flexWrap: "wrap",
      padding: "0 4px",
      width: "100%",
    },
    column: {
      flex: `${100 / columnCount}%`,
      maxWidth: `${100 / columnCount}%`,
      padding: "0 4px",
      transition: "all 0.3s ease",
    },
    image: {
      width: "100%",
      marginTop: "8px",
      verticalAlign: "middle",
      borderRadius: "4px",
      transition: "transform 0.3s ease",
    },
    header: {
      textAlign: "center",
      padding: "32px",
      width: "100%",
    },
  };

  return (
    <section className="custom-gallery-section">
      <div className="container-fluid">
        {/* Header Section */}
        <div className="row">
          <div className="col-12">
            <div style={styles.header}>
              <h1 style={{ color: "#f36d21", marginBottom: "16px" }}>
                Photo Gallery
              </h1>
            </div>
          </div>
        </div>

        {/* Gallery Section */}
        <div className="row pb-5">
          <div className="col-12">
            <div className="container-fluid">
              {isLoading ? (
                <div className="text-center py-5">
                  <p>Loading images...</p>
                </div>
              ) : error ? (
                <div className="text-center py-5">
                  <h5 className="text-danger">{error}</h5>
                  <p className="text-muted">Please try again later</p>
                </div>
              ) : galleryImages.length > 0 ? (
                <div style={styles.galleryRow}>
                  {columns.map((column, columnIndex) => (
                    <div key={columnIndex} style={styles.column}>
                      {column.map((image, imageIndex) => {
                        const actualIndex =
                          columnIndex + imageIndex * columnCount;
                        return (
                          // <LazyLoad height={400} offset={200} once>
                          //   <img
                          //     key={actualIndex}
                          //     src={image.src}
                          //     alt={image.alt}
                          //     style={styles.image}
                          //     onError={(e) => {
                          //       e.target.src = NotFound; // fallback on error
                          //     }}
                          //     onMouseEnter={(e) => {
                          //       e.target.style.transform = "scale(1.02)";
                          //     }}
                          //     onMouseLeave={(e) => {
                          //       e.target.style.transform = "scale(1)";
                          //     }}
                          //   />
                          // </LazyLoad>
                          <img
                            key={actualIndex}
                            src={image.src}
                            alt={image.alt}
                            loading="lazy"   // ⭐ THIS is replacement
                            style={styles.image}
                            onError={(e) => {
                              e.target.src = NotFound;
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = "scale(1.02)";
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = "scale(1)";
                            }}
                          />
                        );
                      })}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <img
                    src={NotFound}
                    alt="No gallery data"
                    style={{ maxWidth: "400px", width: "100%" }}
                  />
                  <p className="mt-3 text-muted">No gallery images available</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
